import { useMemo } from 'react';
import { useQuery } from '@common-fe/common-fe';

import { api } from '@/api';
import { OrganizationTypes } from '@/common/constants';
import { API_URL } from '@/dtos';
import { useCurrentOrganization } from '@/modules/core/hooks';

const QUERY_KEY = 'TOTAL_EMPLOYEES_QUERY';
const useTotalEmployeesQuery = () => {
  const {
    observingOrganization: { type, id },
  } = useCurrentOrganization();

  const isSystemLevel = useMemo(() => type === OrganizationTypes.system, [type]);

  const { isLoading, data, isSuccess } = useQuery(
    [QUERY_KEY, id, type],
    () => api.get(API_URL.METRICS_EMPLOYEES),
    {
      enabled: !isSystemLevel,
    }
  );

  const total = useMemo(() => data?.data?.total_employees_count || 0, [data?.data?.total_employees_count]);

  const isEmpty = useMemo(
    () => isSystemLevel || (isLoading && !isSuccess),
    [isLoading, isSuccess, isSystemLevel]
  );

  return {
    isEmpty,
    isLoading,
    isSuccess,
    total,
  };
};
export default useTotalEmployeesQuery;
